import { Lock, CreditCard } from "lucide-react";
import logoKitMarca from "@/assets/logo-kitmarca.png";
import { Link } from "react-router-dom";
import { getDebugTimeInfo } from "@/lib/timezone";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12 sm:py-16 px-5 sm:px-6 overflow-hidden border-t-0 relative z-10">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col items-center gap-8">
          
          {/* Logo e Nome */}
          <div className="flex items-center gap-2">
            <img src={logoKitMarca} alt="ClickLogos" className="w-8 h-8" />
            <span className="font-bold text-white">ClickLogos</span>
          </div>

          {/* Bloco A: Links Institucionais */}
          <nav className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-sm">
            <Link to="/termos" className="hover:text-white transition-colors">
              Termos de Uso
            </Link>
            <Link to="/privacidade" className="hover:text-white transition-colors">
              Política de Privacidade
            </Link>
            <a 
              href="mailto:suporteclicklogos@gmail.com" 
              className="hover:text-white transition-colors"
            >
              Contato
            </a>
          </nav>

          {/* Bloco B: Selos de Confiança */}
          <div className="flex flex-col sm:flex-row items-center gap-6 text-xs">
            <div className="flex items-center gap-2 text-green-400">
              <Lock className="w-4 h-4" />
              <span>Ambiente Seguro</span>
            </div>
            <div className="flex items-center gap-2">
              <CreditCard className="w-4 h-4" />
              <span>Pagamento via Mercado Pago</span>
            </div>
          </div>

          {/* Bloco C: Dados Legais */}
          <div className="text-center text-xs space-y-1 text-gray-400">
            <p>© 2025 ClickLogos. Todos os direitos reservados.</p>
            <p>CNPJ: 42.373.485/0001-09</p>
          </div>

          {/* Debug: Timezone Info (temporary) */}
          <div className="text-center text-[10px] text-gray-600 font-mono">
            <p>Debug: {getDebugTimeInfo().brazil} | UTC: {getDebugTimeInfo().utc}</p>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
